import { FileText, AlertCircle } from 'lucide-react';

/**
 * Markdown Preview Panel Component
 */
export function PreviewPanel({ markdown, html, mode = 'markdown', onChangeMode, error, hasData }) {
  if (!hasData) {
    return (
      <div className="card p-6 flex items-center justify-center min-h-[500px] animate-fade-in">
        <div className="text-center max-w-md">
          <div className="w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center mx-auto mb-4">
            <FileText className="w-8 h-8 text-slate-400" />
          </div>
          <h3 className="text-lg font-semibold text-slate-900 mb-2">No File Loaded</h3>
          <p className="text-sm text-slate-500">
            Upload a Google AI Studio JSON export to see the Markdown preview here.
          </p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="card p-6 animate-fade-in">
        <div className="flex items-start gap-3 p-4 bg-red-50 border border-red-200 rounded-lg">
          <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="text-sm font-semibold text-red-900 mb-1">Conversion Error</h3>
            <p className="text-sm text-red-700">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="card p-6 animate-fade-in">
      <div className="flex items-center gap-2 border-b border-slate-200 pb-4 mb-4">
        <FileText className="w-5 h-5 text-slate-700" />
        <h2 className="text-lg font-semibold text-slate-900">Preview</h2>
        <div className="ml-auto flex items-center gap-2">
          <span className="text-xs text-slate-500 hidden sm:inline">{markdown.length.toLocaleString()} chars</span>
          <div className="flex rounded-md overflow-hidden border border-slate-200">
            <button
              className={`px-2 py-1 text-xs ${mode === 'markdown' ? 'bg-slate-200 text-slate-900' : 'bg-white text-slate-600'} hover:bg-slate-100`}
              onClick={() => onChangeMode && onChangeMode('markdown')}
            >
              Markdown
            </button>
            <button
              className={`px-2 py-1 text-xs border-l border-slate-200 ${mode === 'html' ? 'bg-slate-200 text-slate-900' : 'bg-white text-slate-600'} hover:bg-slate-100`}
              onClick={() => onChangeMode && onChangeMode('html')}
            >
              HTML
            </button>
          </div>
        </div>
      </div>
      
      {mode === 'markdown' ? (
        <div className="relative">
          <pre className="whitespace-pre-wrap leading-relaxed text-sm text-slate-800 max-h-[70vh] overflow-auto p-4 bg-slate-50 rounded-lg border border-slate-200 font-mono">
            {markdown}
          </pre>
        </div>
      ) : (
        <div className="relative">
          <div className="prose prose-slate max-w-none text-sm leading-relaxed max-h-[70vh] overflow-auto p-4 bg-white rounded-lg border border-slate-200">
            <div dangerouslySetInnerHTML={{ __html: html }} />
          </div>
        </div>
      )}
    </div>
  );
}
